import { useState } from "react";
import DriveContext from "./driveContext";
import { useSelector } from "react-redux";

const DriveState = ({ children }) => {
  const [albums, setAlbums] = useState([]);
  const [currentPage, setCurrentPage] = useState("albums");
  const [selectedAlbum, setSelectedAlbum] = useState({});
  const [albumName, setAlbumName] = useState("");
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  let userId = useSelector((state) => state.user._id);
  const getAlbums = async () => {
    const response = await fetch(
      `${apiBaseUrl}/mediaAgencyRouter/getAlbumsForSas?user=${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
      }
    );
    const data = await response.json();
    if (data.success) {
      setAlbums(data?.albums);
    }
  };
  const UploadZip = async (fileName, mime) => {
    const requestBody = { mime, fileName };

    try {
      // console.log("Sending upload policy request:", requestBody);
      const response = await fetch(
        `${apiBaseUrl}/mediaAgencyRouter/getUploadZipPolicy`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok) {
        console.error(
          "Failed to fetch upload policy:",
          response.status,
          response.statusText
        );
        return null;
      }

      const data = await response.json();
      console.log("Upload policy response:", data);
      return data;
    } catch (error) {
      console.error("Error fetching upload policy:", error);
      return null;
    }
  };
  return (
    <DriveContext.Provider
      value={{
        albums,
        setAlbums,
        currentPage,
        setCurrentPage,
        apiBaseUrl,
        userId,
        getAlbums,
        selectedAlbum,
        setSelectedAlbum,
        UploadZip,
        albumName,
        setAlbumName,
        userId
      }}
    >
      {children}
    </DriveContext.Provider>
  );
};

export default DriveState;
